// https://www.npmjs.com/package/@vue/cli-plugin-pwa#example-configuration
module.exports = {
  publicPath: process.env.NODE_ENV === 'production'
    ? '/monrelevekm/'
    : '/',
  configureWebpack: {
    performance: { hints: false }
  },
}
